define('collections/Podio.Collections.Organizations',['require','lib/backbone/Backbone.PodioCollection','lib/Podio.Routes','lib/Podio.Utils.Text','models/Podio.Models.Organization'],function(require) {

  var PodioCollection = require('lib/backbone/Backbone.PodioCollection');
  var routes = require('lib/Podio.Routes');
  var textUtils = require('lib/Podio.Utils.Text');

  return PodioCollection.extend({

    configure: function() {
      this.model = require('models/Podio.Models.Organization');
    },

    getOrganizations: function() {
      this.url = routes.organizations_path();
      return this.fetch({ reset: true });
    },

    clearFilter: function() {
      this.reset(this.nonFilteredModels);
      this.nonFilteredModels = null;
      this.filterQuery = null;
    },

    filterByName: function(keyword) {

      if (!this.nonFilteredModels) {
        this.nonFilteredModels = this.models;
      }

      if (this.filterQuery !== keyword) {
        this.reset(this.nonFilteredModels, { silent: true });
      }

      var queryRegex = new RegExp(textUtils.regexEscape(keyword), 'gi');

      var filteredModels = this.filter(function(organization) {
        return organization.get('name').search(queryRegex) !== -1;
      });

      this.filterQuery = keyword;

      this.reset(filteredModels);

    }


  });

});

